import React, { useState, useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';

// Notistack
import { useSnackbar } from 'notistack';

// Material-UI
import { Button, Divider, Dialog, DialogContent, DialogActions } from '@material-ui/core';

// Services
import { deleteFederatedAssociation } from 'services/requests';

// Components
import Spinner from 'components/spinner';

// -------------------------------------------------------------------------------------- \\
// ---------------------------- DELETE FEDERATED ASSOCIATION ---------------------------- \\
// -------------------------------------------------------------------------------------- \\

export default function DeleteFederatedAssociation({ federated_association, onClose }) {
    const { enqueueSnackbar } = useSnackbar();
    const history = useHistory();
    const match = useRouteMatch();
    const [loading, setLoading] = useState(false);
    const backUrl = match.path.split('/:federatedAssociationId')[0];

    useEffect(() => {
        if (loading) {
            deleteFederatedAssociation(federated_association.id).then(res => {
                if (res.status === 200) {
                    enqueueSnackbar(res.data.message, { variant: 'success' });
                    history.push(backUrl);
                }
                else {
                    enqueueSnackbar(res, { variant: 'error' });
                    setLoading(false);
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading]);

    return (
        <Dialog open>
            {loading ? (
                <Spinner />
            ) : (
                <>
                    <DialogContent style={{ paddingBottom: 20 }}>
                        <p className="dialog-title">
                            {federated_association.name}
                        </p>
                        Êtes-vous sûr de vouloir supprimer cette association fédérée ?
                    </DialogContent>
                    <Divider />
                    <DialogActions style={{ justifyContent: 'space-between' }}>
                        <Button onClick={onClose} variant="contained">
                            Non
                        </Button>
                        <Button onClick={() => setLoading(true)} variant="contained">
                            Oui
                        </Button>
                    </DialogActions>
                </>
            )}
        </Dialog>
    );
}
